module.exports = __webpack_public_path__ + "img/tx_service.0cf3f74c.png";